import React from 'react';
import PropTypes from 'prop-types';
import useSummitState from '../../hooks/useSummitState';

export const RewardsContext = React.createContext();

export const RewardsContextProvider = ({
  initialTotalAmount = 0,
  initialTier = 0,
  initialHouseholdBalance = 0,
  children
}) => {
  const state = useSummitState({
    initialTotalAmount,
    initialTier,
    initialHouseholdBalance
  });

  return (
    <RewardsContext.Provider value={state}>{children}</RewardsContext.Provider>
  );
};

RewardsContextProvider.propTypes = {
  initialTotalAmount: PropTypes.number,
  initialTier: PropTypes.number,
  initialHouseholdBalance: PropTypes.number
};
